"use client";
import React__default, { useMemo } from 'react';
import { decoratePropsByDefaultValues, splitProps } from '../../../utils/props.js';
import { CustomPropsProvider } from '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { MenuItemVisibleProvider } from '../../Providers/MenuItemVisibleProvider/src/MenuItemVisibleProvider.js';
import { DesktopHeaderContent } from './DesktopHeaderContent.js';

/**
 * @description Desktop header component.
 *
 * @component
 * @example
 * ```jsx
 * <DesktopHeader user={user} settings={settings} />
 * ```
 */
const DesktopHeader = React__default.forwardRef((props, ref) => {
    const [customProps, headerContentProps] = useMemo(() => {
        const [c, rest] = splitProps(props);
        return [decoratePropsByDefaultValues(c), rest];
    }, [props]);
    return (React__default.createElement(CustomPropsProvider, { value: customProps },
        React__default.createElement(MenuItemVisibleProvider, { value: undefined },
            React__default.createElement(DesktopHeaderContent, { ref: ref, ...headerContentProps }))));
});
DesktopHeader.displayName = 'DesktopHeader';

export { DesktopHeader };
//# sourceMappingURL=DesktopHeader.js.map
